export const javascriptFilePathRegex = /\.\/([A-Za-z0-9-_]+)\.js/i;
export const MORTGAGE_TYPE_PARSER = {
  first: 0,
  second: 1,
  third: 2
};
export const VALID_APPLICATION_SUB_TABS = ["documents", "filogix", "direct-to-lender", "forms", "internal-notes"];
export const ACCOUNT_STATUS = {
  pendingEmailVerification: "pending-email-verification",
  pendingActivation: "pending-activation"
};
export const MAINTENANCE_MODE_INTERVAL_MS = 60000 * 10;
export const DEFAULT_DISCLAIMER_ID = "default-disclaimer";
export const V_SELECT_SCENARIO = {
  referrers: "referrers",
  agents: "agents",
  simple: "simple",
  documents: "documents",
  lenderProduct: "lenderProduct"
};
export const GRAVEYARD_BROKERAGE_ID = "192";